import React from "react";
import { useTranslation } from "react-i18next";
import "./TermsAndConditions.css";

const TermsAndConditionsUKContent = () => {

  const { t } = useTranslation("common");

  return (
    <>
      <div className="row">
        <div className="col-xs-12">
          <div className="ukModalDetails">
            <p>
              Unless otherwise defined, any capitalised terms used in the terms
              and conditions below shall have the same meanings as set out in
              the American Express® Corporate Programme Terms and
              Conditions/Global Master Agreement, as applicable. For the
              purposes of this application, all references to “business” means
              the relevant company or firm on behalf of which you are completing
              this application.
            </p>
            <p>
              You warrant that you have complied with and will continue to
              comply with all applicable rules, regulations, judicial or
              governmental authorities to authorise the transfer of the data as
              provided for herein and the information herein is correct and that
              you will notify American Express of any changes. On behalf of the
              business you confirm that: (i) you have informed the person(s)
              named in this application of the purposes of the processing
              carried out by American Express; and (ii) you have the authority
              of the person(s) named in this application to disclose their
              details to American Express. Where the information provided
              constitutes personal information, you understand that such
              information will be processed in compliance with applicable data
              protection legislation. Such personal information shall only be
              obtained for the purposes stated in this application. You
              acknowledge that personal data provided in this application may be
              processed in accordance with applicable data protection law for
              the purposes of administrating your participation in the
              Programme(s).
            </p>
            <p>
              For further information on how American Express collects and
              processes data please refer to the American Express Corporate
              Programme Terms and Conditions/Global Master Agreement, as
              applicable, entered into between American Express and the
              business. If the person(s) named in this application is not an
              existing Program Administrator and is employed by an Affiliate
              legal entity or a third party servicing centre outside the United
              Kingdom (UK) or European Economic Area (EEA) or whose
              correspondence address is outside the UK or EEA that you wish
              American Express to send data or data files on your behalf, you
              hereby authorise and request American Express and/or American
              Express's Affiliates to send, transmit, provide, provide access to
              or make available certain data relating to you and your
              Affiliates' individual employees, contractors or agents who use
              the Services to that PA/Affiliate legal entity any data which the
              PA is entitled to receive. You shall ensure: (a) you have the
              authority from your employees, contractors or agents that use the
              Programme (“Individuals”) and any Individuals of your Affiliates
              to request sending the data or making it available on a global
              basis; and (b) the consent of such Individuals is obtained where
              required by applicable law. American Express does not take
              responsibility for any information sent or made available to a
              PA/legal entity on such authorisation by you. You agree that
              American Express will effectuate the transfers upon your request
              with no liability for the further processing undertaken by the
              PA/Affiliate legal entity.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditionsUKContent;